import React from 'react';
import { 
  MenuIcon,
  XIcon,
} from '../Icons';
import AvatarDropdownWrapper from 'components/AvatarDropdownWrapper/AvatarDropdownWrapper';
import NotificationDropdownWrapper from 'components/NotificationDropdownWrapper/NotificationDropdownWrapper';
import PostSearch from 'components/PostSearch/PostSearch';
import { useCourseStatus } from 'hooks/course/useCourseStatus';
import { useCourseId } from 'hooks/course/useCourseId';
import { useAuth } from 'contexts/AuthContext';
import { isConversasCourseType } from 'utils/enrollmentAccess';
import { useProductFavicon } from 'hooks/useFavicon';

type HeaderProps = {
  isSidebarOpen: boolean;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Header: React.FC<HeaderProps> = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const courseId = useCourseId();
  const { canAccessCommunity } = useCourseStatus(courseId);
  const { user } = useAuth();
  const isConversas = isConversasCourseType(user, courseId ?? '');
  const title = isConversas ? 'Conversas Terapêuticas' : 'Clube do Livro';
  const shortTitle = isConversas ? 'CT' : 'CL';
  useProductFavicon(isConversas);

  return (
      <header className="bg-white dark:bg-gray-800 shadow-sm fixed top-0 left-0 right-0 z-40">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              >
                {isSidebarOpen ? <XIcon size={24} /> : <MenuIcon size={24} />}
              </button>
              <h1 className="hidden lg:block ml-4 text-xl font-semibold text-gray-900 dark:text-white">{title}</h1>
              <h1 className="block lg:hidden ml-4 text-xl font-semibold text-gray-900 dark:text-white">{shortTitle}</h1>

            </div>
            { canAccessCommunity && <PostSearch/> }

            <div className="flex items-center gap-2">            
              <NotificationDropdownWrapper/>
              <AvatarDropdownWrapper/>
            </div>
          </div>
        </div>
      </header>
    );
};

export default Header;